var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-container',{staticClass:"automation-workspace",attrs:{"custom":1600,"min-height":0,"tabindex":"-1"}},[_c('router-view',{key:_vm.$route.params.run_id || 'list'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }